import { SortDirection } from '@mesa-labs/mesa-api/dist/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const PaginationLimits = [
  { key: '10', value: 10 },
  { key: '25', value: 25 },
  { key: '50', value: 50 },
  { key: '100', value: 100 },
];

export type InvoiceDisclosuresState = {
  page: number;
  limit: { key: string; value: number };
  total?: number;
  searchTerm?: string;
  sortField?: string;
  sortDirection: SortDirection;
};

const initialState: InvoiceDisclosuresState = {
  page: 1,
  limit: PaginationLimits[0],
  total: undefined,
  searchTerm: undefined,
  sortField: 'eligibleAt',
  sortDirection: SortDirection.DESCENDING,
};

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    updatePage(state: InvoiceDisclosuresState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    updateLimit(state: InvoiceDisclosuresState, action: PayloadAction<{ key: string; value: number }>) {
      state.limit = action.payload;
    },
    updateTotal(state: InvoiceDisclosuresState, action: PayloadAction<number>) {
      state.total = action.payload;
    },
    updateSearchTerm(state: InvoiceDisclosuresState, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    updateSortField(state: InvoiceDisclosuresState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: InvoiceDisclosuresState, action: PayloadAction<SortDirection>) {
      state.sortDirection = action.payload;
    },
  },
});

export const {
  updatePage,
  updateLimit,
  updateTotal,
  updateSearchTerm,
  updateSortField,
  updateSortDirection,
} = invoicesSlice.actions;
export default invoicesSlice.reducer;
